"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.578 2.901c.568-1.201 2.276-1.201 2.844 0l1.624 3.436 3.585.474c1.267.168 1.813 1.694.95 2.63l-2.62 2.844.717 3.847c.237 1.277-1.088 2.284-2.255 1.696L10 16.102l-3.423 1.726c-1.167.588-2.492-.42-2.255-1.696l.716-3.847-2.62-2.844c-.861-.936-.316-2.462.951-2.63l3.585-.474z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=StarFilledNavIcon20.js.map